var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"prompt"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('system.404')))]),_c('router-link',{attrs:{"to":{ path: '/' }}},[_vm._v("Back to home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }